export const manufacturingEs = {
  title: 'Órdenes de producción',
  subtitle:
    'Planificar recetas aprobadas, consumir por lote y completar la producción con trazabilidad íntegra.',
  help: {
    open: 'Abrir ayuda de órdenes de producción',
    detail: 'Abrir ayuda sobre planificación, movimientos y finalización',
  },
  actions: {
    new: 'Nueva orden',
    plan: 'Planificar',
    release: 'Liberar',
    reserve: 'Reservar material',
    start: 'Iniciar',
    pause: 'Pausar',
    resume: 'Reanudar',
    reportComplete: 'Notificar terminación',
    close: 'Cerrar',
    cancel: 'Cancelar',
    issue: 'Retirar',
    return: 'Devolver',
    confirmStep: 'Confirmar',
    comment: 'Comentario',
    post: 'Contabilizar',
  },
  filters: {
    search: 'Buscar número, artículo o demanda',
    status: 'Estado',
    allStatuses: 'Todos los estados',
    priority: 'Prioridad',
    allPriorities: 'Todas las prioridades',
    from: 'Inicio desde',
    to: 'Inicio hasta',
  },
  statuses: {
    DRAFT: 'Borrador',
    PLANNED: 'Planificada',
    RELEASED: 'Liberada',
    MATERIAL_RESERVED: 'Material reservado',
    IN_PRODUCTION: 'En producción',
    PAUSED: 'Pausada',
    REPORTED_COMPLETE: 'Terminación notificada',
    CLOSED: 'Cerrada',
    CANCELLED: 'Cancelada',
  },
  priorities: { LOW: 'Baja', NORMAL: 'Normal', HIGH: 'Alta', URGENT: 'Urgente' },
  columns: {
    number: 'Orden',
    product: 'Producto terminado',
    status: 'Estado',
    priority: 'Prioridad',
    recipe: 'Receta',
    planned: 'Previsto',
    produced: 'Producido',
    start: 'Inicio',
    updated: 'Modificado',
    position: 'Pos.',
    material: 'Material',
    reserved: 'Reservado',
    issued: 'Retirado',
    returned: 'Devuelto',
    scrap: 'Merma',
    variance: 'Desviación',
    step: 'Operación',
    workCenter: 'Puesto de trabajo',
    duration: 'Duración (min)',
    input: 'Entrada',
    output: 'Salida',
    type: 'Tipo',
    batch: 'Lote',
    quantity: 'Cantidad',
  },
  empty: 'No se encontraron órdenes de producción.',
  editor: {
    newTitle: 'Crear orden de producción',
    subtitle: 'El escalado en servidor calcula necesidades desde una receta y ruta aprobadas.',
    plan: 'Base de planificación',
    planDescription:
      'Defina origen, cantidad, fechas, almacenes y responsables. Los borradores usan bloqueo optimista.',
  },
  fields: {
    recipe: 'Receta aprobada',
    routing: 'Ruta aprobada',
    plannedQuantity: 'Cantidad prevista',
    unit: 'Unidad',
    priority: 'Prioridad',
    salesOrder: 'Pedido de cliente',
    plannedStart: 'Inicio previsto',
    plannedEnd: 'Fin previsto',
    sourceWarehouse: 'Almacén de salida',
    targetWarehouse: 'Almacén de destino',
    internalDemand: 'Demanda interna',
    responsibleUsers: 'Personas responsables',
    note: 'Nota / motivo',
    postingType: 'Tipo de movimiento',
    quantity: 'Cantidad',
    reason: 'Motivo',
    stepResult: 'Resultado',
    inputQuantity: 'Cantidad de entrada',
    outputQuantity: 'Cantidad de salida',
    scrapQuantity: 'Cantidad de merma',
    duration: 'Duración real (min)',
    qualityChecks: 'Controles de calidad obligatorios',
    producedQuantity: 'Cantidad producida',
    batchNumber: 'Nuevo número de lote',
    bestBefore: 'Consumo preferente',
  },
  shortage: {
    title: 'Falta de material',
    description: '{{count}} posición(es) no pueden cubrirse totalmente con el stock libre actual.',
  },
  tabs: {
    materials: 'Materiales y consumo',
    process: 'Proceso y calidad',
    outputs: 'Salidas',
    history: 'Historial y comentarios',
    documents: 'Documentos DMS',
  },
  documents: { title: 'Expediente de producción' },
  summary: {
    planned: 'Cantidad prevista',
    produced: 'Producido',
    scrap: 'Merma',
    yield: 'Rendimiento real',
    plannedCost: 'Coste material previsto',
    actualCost: 'Coste material real',
  },
  materials: {
    title: 'Posiciones de material',
    description:
      'Necesidades, reservas y movimientos por lote permanecen separados y usan decimales exactos.',
  },
  process: {
    title: 'Confirmaciones de proceso',
    description: 'Las operaciones, parámetros y controles proceden de la instantánea aprobada.',
  },
  stepStatuses: {
    PENDING: 'Pendiente',
    IN_PROGRESS: 'En curso',
    COMPLETED: 'Completada',
    SKIPPED: 'Omitida con motivo',
  },
  outputs: {
    title: 'Salidas y lotes producidos',
    description: 'Producto terminado, subproductos y mermas de la finalización.',
    empty: 'Todavía no hay salidas contabilizadas.',
  },
  outputTypes: { FINISHED_GOOD: 'Producto terminado', BYPRODUCT: 'Subproducto', SCRAP: 'Merma' },
  history: {
    title: 'Historial inmutable',
    description: 'Cada operación conserva clave de idempotencia, hash, usuario y fecha.',
  },
  comments: {
    title: 'Comentarios',
    description: 'Notas de solo adición en el expediente auditado.',
    empty: 'Todavía no hay comentarios.',
  },
  operationTypes: {
    CREATE: 'Creada',
    UPDATE: 'Borrador modificado',
    PLAN: 'Planificada',
    RELEASE: 'Liberada',
    RESERVE: 'Reservado',
    ISSUE: 'Material retirado',
    RETURN: 'Material devuelto',
    START: 'Iniciada',
    PAUSE: 'Pausada',
    RESUME: 'Reanudada',
    STEP_CONFIRM: 'Paso confirmado',
    REPORT_COMPLETE: 'Terminación notificada',
    CLOSE: 'Cerrada',
    CANCEL: 'Cancelada',
    COMMENT: 'Comentario añadido',
  },
  workflow: {
    plan: {
      title: 'Planificar orden',
      description: 'La instantánea queda congelada y ya no admite cambios estructurales.',
    },
    release: {
      title: 'Liberar orden',
      description: 'Las fuentes aprobadas y necesidades previstas pasan a ser la base vinculante.',
    },
    start: {
      title: 'Iniciar producción',
      description: 'Se registra el inicio real y las retiradas por lote siguen trazables.',
    },
    pause: {
      title: 'Pausar producción',
      description: 'La orden sigue admitiendo movimientos, pero aparece pausada.',
    },
    resume: { title: 'Reanudar producción', description: 'La orden vuelve a producción activa.' },
    close: {
      title: 'Cerrar orden',
      description: 'Se liberan reservas abiertas y la orden cerrada queda inmutable.',
    },
  },
  reserve: {
    title: 'Reservar automáticamente stock libre',
    description: 'La selección es transaccional según FEFO/FIFO; las faltas permanecen visibles.',
  },
  materialDialog: {
    ISSUE: { title: 'Contabilizar retirada' },
    SCRAP: { title: 'Contabilizar merma de material' },
    RETURN: { title: 'Contabilizar devolución' },
  },
  materialActions: { ISSUE: 'Retirada', SCRAP: 'Merma', RETURN: 'Devolución' },
  quality: { PASS: 'Superado', FAIL: 'No superado', NOT_CHECKED: 'No comprobado' },
  stepDialog: { title: 'Confirmar paso del proceso' },
  report: {
    title: 'Notificar producción terminada',
    description: 'El lote terminado y las entradas de stock se crean juntos en una transacción.',
  },
  cancel: {
    title: 'Cancelar orden de producción',
    description: 'Se exige un motivo y no puede quedar consumo real sin devolver.',
  },
  comment: {
    title: 'Añadir comentario',
    description: 'La entrada se guarda de forma inmutable con usuario y fecha.',
  },
  messages: {
    created: 'Orden de producción creada.',
    saved: 'Borrador guardado.',
    workflow: 'Estado actualizado.',
    reserved: 'Material disponible reservado.',
    posted: 'Movimiento de material contabilizado.',
    stepConfirmed: 'Paso del proceso confirmado.',
    completed: 'Producción notificada como terminada.',
    cancelled: 'Orden de producción cancelada.',
    commented: 'Comentario añadido.',
  },
} as const;
